<template>
  <div class="animated fadeIn">
    <basic-heading title="New Test Package Group" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add test package group'">
      <template #gated-content>
        <test-package-group-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TestPackageGroupForm from "@/components/lab/testpackagegroup/form/TestPackageGroupForm";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testPackageGroupNotifications } from "@/shared/notifications";

Vue.use(VueNotifications, notificationOptions);

const TestPackageGroupRepository = LabRepositoryFactory.get("testPackageGroup");

export default {
  name: "TestPackageGroupAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestPackageGroupForm,
  },
  data() {
    return {
      laboratory_id: this.$store.getters.getLaboratoryContext.id,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/testpackagegroups",
            title: "To the Test package groups page",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      const payload = {
        ...form_data,
        laboratory_id: this.laboratory_id,
      };

      try {
        const { data } = await TestPackageGroupRepository.create(payload);

        this.addSuccess();
        this.$router.push(`/testpackagegroups/${data.id}`);
      } catch ({ response }) {
        this.addFail();
      }
    },
  },
  notifications: testPackageGroupNotifications,
};
</script>
